import { NetworkConnectionProvider } from './../../providers/network-connection/network-connection';
import { Component, NgZone } from '@angular/core';
import { NavController, NavParams, LoadingController, /*AlertController,*/ ToastController } from 'ionic-angular';
import { User } from "../../model/user";
import { AngularFireAuth } from 'angularfire2/auth';
import { IonicPage, Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { LokiDbProvider } from '../../providers/loki-db/loki-db';
import { FirebaseServiceProvider } from '../../providers/firebase-service/firebase-service';
import * as firebaseApp from 'firebase/app';
/**
 * Generated class for the LoginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
})
export class LoginPage {

    statusLogin: string;

    showLogin = false;

    constructor(private translateService: TranslateService,
        private autenticazione: AngularFireAuth,
        public navCtrl: NavController, public navParams: NavParams,
        public network: NetworkConnectionProvider,
        private lokiDB: LokiDbProvider,
        private firebase: FirebaseServiceProvider,
        private loadingCtrl: LoadingController,
        private platform: Platform,
        private toastCtrl: ToastController,
        private zone: NgZone

    ) {

        /**
         * Metodi richiamati quando l'app viene chiusa e riaperta
         */
        platform.ready().then(() => {
            this.platform.pause.subscribe(() => {
                console.log('[INFO] App paused');
            });

            this.platform.resume.subscribe(() => {
                console.log('[INFO] App resumed');
            });

            this.showLogin = false


            firebaseApp.auth().onAuthStateChanged(user => {
                //console.log("on auth state changed")
                if (user) {

                    //this.zone.run(() => {this.showLogin = false})
                    console.log("signed in -> ");
                    console.log(user);

                    //console.log("waiting token...")
                    this.lokiDB.getTokenWaiter().then(() => {

                        this.lokiDB.checkLoginDomain(user).then((ok) => {
                            let isDesktop1024 = this.platform.is('core') && this.platform.width() > 1024
                            if (ok) {
                                this.lokiDB.trackUserMail(user);
                                if (!isDesktop1024) {
                                    //console.log("OK Check domain")
                                    let tabIdx = this.lokiDB.getHomePage();
                                    //console.log(tabIdx)
                                    if (isNaN(tabIdx) || !this.lokiDB.allDataLoaded) {
                                        //console.log("root to welcome page")
                                        //Mai entrato vado diretto a Login
                                        this.navCtrl.setRoot('WelcomePage');
                                    } else {
                                        //console.log("root to tabs page")
                                        //se è un numero vado diretto ai tabs 
                                        this.navCtrl.setRoot('TabsPage');
                                    }
                                } else {
                                    this.navCtrl.setRoot('WelcomePage');
                                }
                            } else {
                                this.zone.run(() => {
                                    console.log("NOT OK check domain...")
                                    this.showLogin = true;
                                    this.statusLogin = this.translateService.instant("DOMAIN_NOTALLOWED")
                                })
                            }
                        }).catch((err) => {
                            console.log("Error check login domain " + err)
                            this.statusLogin = err;

                        });
                    });
                } else {
                    console.log("User not logged, go to google login...")
                    this.LoginWithGoogle();
                    console.log("not Signed");
                }
            });
        });

    }

    ionViewDidEnter() {
        this.lokiDB.trackPage(this.constructor.name)
    }  

    ionViewWillEnter() {
        this.showLogin = false
        this.statusLogin = ""
    }

    abort(){
        this.showLogin = true
        this.statusLogin = ""
    }


    /*
      Metodo di login tramite pulsante della schermata iniziale
    */
    private LoginWithGoogle() {
        try {
            //Sign out preventivo per gestire bene caso di invalid domain
            firebaseApp.auth().signOut();
            this.showLogin = false
            this.statusLogin = ""
            setTimeout(() => this.zone.run(() => {
                try {
                    this.showLogin = true
                    this.statusLogin = "You are not logged in."
                } catch (e) { }
            }), 90000)
        } catch (e) { }


        try {

            console.log("Trying to login with google...")

            let provider = new firebaseApp.auth.GoogleAuthProvider();

            provider.setCustomParameters({ prompt: 'select_account' });

            firebaseApp.auth().signInWithPopup(provider);


        }//fine try
        catch (e) {
            /*******
             *  catturo l'eventuale errore, gestisco alcuni casi
             *  come utente non esiste, password errata etc..
            ********/
            console.log("error ->" + e + " code ->" + e.code);

            switch (e.code) {
                case 'auth/user-not-found': //user inesistente
                    this.statusLogin = this.translateService.instant("MSG_LOGIN_FAILED");
                    break;

                case 'auth/wrong-password': //password errata
                    this.statusLogin = this.translateService.instant("MSG_PASSWORD_wRONG");
                    break;

                default: //default error
                    this.statusLogin = e;
            }//fine switch
            /********
             *  Visualizzo l'errore in una toast
             */
            this.toastCtrl.create({
                message: this.statusLogin,
                duration: 2000,
                position: 'top'
            }).present();

        }//fine catch

    } //fine LoginWithEmail



}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts